<template>
	<div>
		<b>{{ question }}</b>
		<b-button v-b-toggle="questionMark" variant="link"
			><b-icon icon="chat-text" variant="danger"></b-icon
		></b-button>

		<b-collapse :id="questionMark" class="mt-2">
			<b-card>
				<p>Comments:</p>
				<b-form-textarea
					id="comments_textarea"
					v-model="commText"
					placeholder="Please add comments..."
					rows="2"
					no-resize
				></b-form-textarea>
			</b-card>
		</b-collapse>
	</div>
</template>
<script>
export default {
	name: "QuestionComments",
	props: {
		question: String,
		//identify which question
		questionMark: String
	},
	data() {
		return {
			/*commText:
				this.$tera.project.commentSet?.find(cs => cs.mark === this.pageMark)
					?.notes ?? {mark: this.pageMark, [this.questionMark]: ""},*/
			//which page at
			pageMark: this.questionMark.includes("-")
				? this.questionMark.split("-")[0]
				: this.questionMark
		};
	},
	computed: {
		commText: {
			get() {
				let notesObj = this.$tera.project.commentSet?.find(
					cs => cs.mark === this.pageMark
				); // Value || Undifined
				return notesObj?.notes?.[this.questionMark] ?? "";
				//return notesObj[this.questionMark] || "";
			},
			// if commText changed, if Set doesnt contain, add New Object to this Set
			set(newValue) {
				if (
					!this.$tera.project.commentSet?.find(cs => cs.mark === this.pageMark)
				) {
					this.$tera.project.commentSet.push({
						mark: this.pageMark,
						notes: { [this.questionMark]: newValue }
					});
				} else {
					let element = this.$tera.project.commentSet?.find(
						cs => cs.mark === this.pageMark
					);
					//element.notes[this.questionMark] = newValue;
					this.$set(element.notes, this.questionMark, newValue);
				}
				console.log(
					"this.$tera.project.commentSet:",
					this.$tera.project.commentSet
				);
			}
		}
	}
	/*watch: {
		// if commText changed, if Set doesnt contain, add New Object to this Set
		commText(newValue) {
			//console.log("COMM-" + this.questionMark + ":", newValue);
			if (
				!this.$tera.project.commentSet?.find(
					cs => cs.mark === this.questionMark
				)
			) {
				this.$tera.project.commentSet.push({
					mark: this.pageMark,
					notes: { [this.questionMark]: newValue }
				});
			} else {
				let element = this.$tera.project.commentSet?.find(
					cs => cs.mark === this.pageMark
				);
				/*if (this.questionMark.includes("-")) {
					let noteIndex = this.questionMark.split("-")[1];
					element.notes[noteIndex] = newValue;
				} else {
					element.notes["0"] = newValue;
				}

				element.notes[this.questionMark] = newValue;
			}
		}
	}*/
};
</script>
<style scoped></style>
